import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.09998 0.75C1.85733 0.75 0.849976 1.75736 0.849976 3V9C0.849976 10.2426 1.85734 11.25 3.09998 11.25H9.09998C10.3426 11.25 11.35 10.2426 11.35 9V3C11.35 1.75736 10.3426 0.75 9.09998 0.75H3.09998ZM2.34998 3C2.34998 2.58579 2.68576 2.25 3.09998 2.25H9.09998C9.51419 2.25 9.84998 2.58579 9.84998 3V9C9.84998 9.41421 9.51419 9.75 9.09998 9.75H3.09998C2.68576 9.75 2.34998 9.41421 2.34998 9V3Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M3.84998 12.75C3.43576 12.75 3.09998 13.0858 3.09998 13.5C3.09998 13.9142 3.43576 14.25 3.84998 14.25H12.1C13.3426 14.25 14.35 13.2426 14.35 12V3.75C14.35 3.33579 14.0142 3 13.6 3C13.1858 3 12.85 3.33579 12.85 3.75V12C12.85 12.4142 12.5142 12.75 12.1 12.75H3.84998Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}